import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import styles from "../../_css/SessionsPerLanguageChart.module.css";
import { DataLoader } from "../common/ResponseLoader";

// const data = [
//   { name: "English", value: 70 },
//   { name: "Arabic", value: 30 },
// ];
const COLORS = ["#234A93", "#FFC94D"];

const renderCustomizedLabel = (
  { cx, cy, midAngle, outerRadius, percent, index },
  data
) => {
  if (index === 0) {
    // English (right side)
    const offset = 8;
    const lineLength = 18;
    const angle = (-midAngle * Math.PI) / 180;
    const sx = cx + outerRadius * Math.cos(angle);
    const sy = cy + outerRadius * Math.sin(angle);
    const ex = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
    const ey = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
    const lx = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
    const ly = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
    return (
      <g>
        <line
          x1={sx}
          y1={sy}
          x2={ex}
          y2={ey}
          stroke="#E5E7EB"
          strokeWidth={2}
        />
        <text
          x={lx}
          y={ly}
          fill="#234A93"
          textAnchor="start"
          dominantBaseline="central"
          fontSize={24}
          fontWeight={700}
        >
          {data[0].value}%
        </text>
      </g>
    );
  } else {
    // Arabic (left side)
    const offset = 8;
    const lineLength = 18;
    const angle = (-midAngle * Math.PI) / 180;
    const sx = cx + outerRadius * Math.cos(angle);
    const sy = cy + outerRadius * Math.sin(angle);
    const ex = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
    const ey = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
    const lx = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
    const ly = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
    return (
      <g>
        <line
          x1={sx}
          y1={sy}
          x2={ex}
          y2={ey}
          stroke="#E5E7EB"
          strokeWidth={2}
        />
        <text
          x={lx}
          y={ly}
          fill="#FFC94D"
          textAnchor="end"
          dominantBaseline="central"
          fontSize={24}
          fontWeight={700}
        >
          {data[1].value}%
        </text>
      </g>
    );
  }
};

const SessionsPerLanguageChart = ({ data }) => (
  <div className={styles.card}>
    <h3 className={styles.title}>Sessions attended per Language</h3>
    {data.length > 0 ? (
      <>
        <ResponsiveContainer width="100%" height={240}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={65}
              outerRadius={90}
              startAngle={90}
              endAngle={-270}
              dataKey="value"
              labelLine={false}
              label={(props) => renderCustomizedLabel(props, data)}
            >
              {data.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className={styles.legendRow}>
          <span
            className={styles.legendDot}
            style={{ background: COLORS[1] }}
          />{" "}
          {data[1].name}
          <span
            className={styles.legendDot}
            style={{ background: COLORS[0], marginLeft: 24 }}
          />{" "}
          {data[0].name}
        </div>
      </>
    ) : (
      <DataLoader />
    )}
  </div>
);

export default SessionsPerLanguageChart;
